import { AxiosPromise } from 'axios';
import { http } from 'services';
import type {
  AnalyticsParams,
  PeopleParams,
  OverviewResponse,
  PeopleResponse,
  TestsResponse,
  ItemAnalysisResponse,
  IntegrityResponse,
} from './types';

// The org is resolved from the auto-injected `X-Organization-Id` header
// (see bootstrap.ts) — never passed as a query param.

export const GetOverview = (params: AnalyticsParams): AxiosPromise<OverviewResponse> =>
  http.request.get('/api/analytics/overview', { params });

export const GetPeople = (params: PeopleParams): AxiosPromise<PeopleResponse> =>
  http.request.get('/api/analytics/people', { params });

export const GetTests = (params: AnalyticsParams): AxiosPromise<TestsResponse> =>
  http.request.get('/api/analytics/tests', { params });

export const GetItemAnalysis = (testId: string, params: AnalyticsParams): AxiosPromise<ItemAnalysisResponse> =>
  http.request.get(`/api/analytics/tests/${testId}/items`, { params });

export const GetIntegrity = (params: AnalyticsParams): AxiosPromise<IntegrityResponse> =>
  http.request.get('/api/analytics/integrity', { params });

// Legacy per-test statistics, still consumed by TestResults/StatisticsPage.
export const GetTestAnalytics = (testId: string): AxiosPromise =>
  http.request.get(`/api/analytics/tests/${testId}`);
